// extracted by mini-css-extract-plugin
module.exports = {"offscreen":"src-hellospa-components-offscreen__offscreen--27qTp"};